import Vue from "vue";
export var WarrantyEventBus = new Vue();